import { render } from "./OwnerAccount.vue?vue&type=template&id=153e9ec0&scoped=true"
import script from "./OwnerAccount.vue?vue&type=script&lang=js"
export * from "./OwnerAccount.vue?vue&type=script&lang=js"

import "./OwnerAccount.vue?vue&type=style&index=0&id=153e9ec0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153e9ec0"]])

export default __exports__